import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AuthNotification.css';
// @ts-expect-error TODO: исправить импорт картинок
import chatImage from './assets/login@2x.png';

type TAuthNotificationProps = {
  onAuthClick(): void;
};

export const AuthNotification: React.FC<TAuthNotificationProps> = ({ onAuthClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['notification']}>
        <img src={chatImage} width={160} height={160} />
        <UIHeading2 color="text-primary-default">Войдите, чтобы писать сообщения</UIHeading2>
        <UIText1 textAlign="center" color="text-secondary-default">
          Сможете переписываться
          <br />с другими пользователями Циан
        </UIText1>
        <Button onClick={onAuthClick} theme="fill_primary">
          Вход или регистрация
        </Button>
      </div>
    </div>
  );
};
